/**
 * @generated SignedSource<<0b2246293aa6d31ed0da90545e2dc531>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type AddReservationLineInput = {
  assetTag: any;
  clientMutationId?: string | null | undefined;
  reservationId: string;
};
export type OpsReservationPageAddLineMutation$variables = {
  input: AddReservationLineInput;
};
export type OpsReservationPageAddLineMutation$data = {
  readonly addReservationLine: {
    readonly reservation: {
      readonly id: string;
    } | null | undefined;
    readonly userErrors: ReadonlyArray<{
      readonly assetTag: any | null | undefined;
      readonly message: string;
    }>;
  } | null | undefined;
};
export type OpsReservationPageAddLineMutation = {
  response: OpsReservationPageAddLineMutation$data;
  variables: OpsReservationPageAddLineMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "AddReservationLinePayload",
    "kind": "LinkedField",
    "name": "addReservationLine",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Reservation",
        "kind": "LinkedField",
        "name": "reservation",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "UserError",
        "kind": "LinkedField",
        "name": "userErrors",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "message",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "assetTag",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "OpsReservationPageAddLineMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "OpsReservationPageAddLineMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "b83749f4a78db67cbc40e310897dec81",
    "id": null,
    "metadata": {},
    "name": "OpsReservationPageAddLineMutation",
    "operationKind": "mutation",
    "text": "mutation OpsReservationPageAddLineMutation(\n  $input: AddReservationLineInput!\n) {\n  addReservationLine(input: $input) {\n    reservation {\n      id\n    }\n    userErrors {\n      message\n      assetTag\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "7c205131703fb5207ee5f5215d66e228";

export default node;
